var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatarMale({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 76,
    viewBox: "0 0 75 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2_2088",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 75,
    height: 76
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 75.8416,
    width: 75.8416,
    height: 74.5983,
    transform: "rotate(-90 0 75.8416)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2_2088)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -10,
    y: -7.00006,
    width: 94,
    height: 94,
    fill: "url(#pattern0_2_2088)",
    fillOpacity: 0.6
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_2_2088",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2_2088",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2_2088",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAAEu0lEQVR4nO2cTYgcRRTHa+K34kGFKCKoiGDMRQ8iKLgiRBfNRj30vP/rnRgJmotivImgrOIXKCJREcSDelGvCoLx+6BGRdGYkLjJJv1eb9aNrnrwM7pKS00muwb2MLPb3VVbXT94sAy7PfV+W1NTXV31jIlEIpFIJBKJRCKRyGAQ6QVAthGkLzD0A4YqSH9myCxIfgOpdF8nfQDILh3w8s1m7dqpkwG5g6FfMrQYMN4FdLXrHDynaDHLbSCZWYTguQDpn9yWUdfZeMn69QfOYMjWpQg+Wrb8m5Le6DovrxgdnTwHkL1lSf6f7BlA7mLWkU5nYqVpMmmqpwH6bdmSF4hDTPISoGeb5lG0QPpmDZLng2Sq3c4vM02C23pLrZLnQn5K0/3nmiYwPLznBIYccCO6O35/aJoAILe7kjwnG7rGhA6g2zwQ/Y4JmU5nYqVryb2xejZJ8tNNqDDnN7mX3IuQ7yAZ+oRzwUeC5CkTKoC+71zw/PCx1YQKQ3a4F3w4QLrPhAqTTPkjWmZMqMAuY3oguReHTKgw5FdvejT0FxMqDBl3LXg+ZNyECpe4wL/kIH3PhAqT3O/R0PGgCRVg8nLXgueC8yETMiDd7VoyoPvHxooVJmQAfca1aCZ91oQMINfYp9SuRds2EGVXm1AByRuuJc/3anndhAp7tNbBJNtNqDDJp84FHxk+oNtMqAD6vD+i5TkTKszZ9f6IzodNyAD6kXPJpJ/YTTwmZDqJnM/Qrx1K/oooO880BSbdUrto0i2maTDrSP3jstxgmkaS7DwepN/XKHp606YvjjNNJCW9p75hQ+40TT6zwtCsetGyY2ioONY0GUDXVLnQFPwC0iAAcl91X4B6r+v8PKJoMeS18iXLq8HfmAxKkhTHlDm3tusqjZ1l9ENZovt6sybDUXQUHRQce3QUHRQce3QNkjkfKkt02s6vqqHJy3XdQ0p7Sg6Sb+w1XeflIUWLSTeD9O+li5ZZW5km+G1fSyFty5W2Ny5aMsl2IrnCdR7LgrGxYkVKeusgtTxAssf+TeN7ccc+lCXdbDeA22Nw/Z5ctYWpAHnYHpZn0oPd+hvdGhx6sPfaQ2maXdLPtTau230qk7xt6y/Zttg2meVP0bL1MawkJtm+QC/cVefTaFsYBZDPFxpq7D/rcC2PZbTSR5StYpJHGZL38ZGfrmM8teN+n6UrFJBHmLOLjJ8ULUDXLW5vnfxjk9uwITux7FYlSX4SII/Z9xh4emirMLCOGF/gdn7dgh/JwSMjUirjy8xeA8i5V4RwqfPxz4j0WuMK+2VW0VORvd35NPadOXibsrMAvZshE2W3i0lesQW3TJ0wT15YRRk1Pron2Qe2H9thJSVNRhO52Iq0Q4wN+7N9DdB2d1y1v1v5aQIZt6U866sZWu/Gl8KnAOl3lc+WuvNQr06/qqvY1elMn1KZaLt524MkCy+C9OmKJOtqH05UsSfR25izqgLR8rLr5NizAOTFKtaKf3edGHsX8kepa95AdrP7pNTLsHfEJYqWJ10nxJ4GoI+XJ5rkLdcJsadhqwaXJrqSW1qEEfYOuTTRIPnRdULsbcgPpYlm6F/uE1JfI9xqY5FIJBKJRCKRSMQ0gv8AFRbPauFNuAMAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarMale);
export default __webpack_public_path__ + "static/media/avatar_male.24ae952d61dfcb3e96036cb4774b3031.svg";
export { ForwardRef as ReactComponent };